// import { Tag } from 'antd';
import { Tag } from 'antd';
import { useMemo } from 'react';

const useStatusTagStyles = (status) => {
  const { color, background, title } = useMemo(() => {
    let color = '';
    let background = '';
    let title = '';
    switch (status) {
      case 0:
      case 'Draft':
        background = '#e6f4ff';
        color = '#0958d9';
        title = status === 0 ? 'Draft' : status;
        break;
      case 1:
      case 'Paid':
      case 'To Deliver and Bill':
      case 'Enabled':
      case 'Yes':
      case 'Open':
      case 'Confirmed':
      case 'Received':
      case 'Ordered':
      case 'Accepted':
      case 'Approved':
      case 'Completed':
      case 'Available':
      case 'Submitted':
        background = '#40C1AC1A';
        color = '#167767';
        title = status === 1 ? 'Submitted' : status;
        break;
      case 'Invoiced':
      case 'Unpaid':
        background = '#f9f0ff';
        color = '#531dab';
        break;
      case 'Error':
        background = '#fff1f0';
        color = '#f5222d';
        break;

      case 'Rejected':
        background = '#ffd8bf';
        color = '#d4380d';
        break;
      case 2:
      case 'Closed':
      case 'Left':
      case 'Overdue':
      case 'Cancelled':
      case 'Not Available':
      case 'Disabled':
      case 'No':
        background = '#EB59591A';
        color = '#EB5959';
        title = status === 2 ? 'Cancelled' : status;
        break;
      case 'Half Day':
      case 'Scheduled':
      case 'To Receive':
        background = '#e6f4ff';
        color = '#0958d9';
        break;
      case 'Payment Created':
        background = '#e6f7ff';
        color = '#1890ff';
        break;

      case 'To Deliver':
      case 'Suspended':
      case 'Accepted with warnings':
      case 'Pending':
      case 'Partly Paid':
        background = '#FFF2CC';
        color = '#FFA500';
        break;
      case 'Checked Out':
      case 'To Bill':
        background = '#f9f0ff';
        color = '#531dab';
        break;
      case 'Manual':
      case 'Work From Home':
        background = '#d3f9d8';
        color = '#389e0d';
        break;
      case 'Automatic':
        background = '#f4e3ff';
        color = '#722ed1';
        break;
      case 'VIP':
        background = '#ffecb3';
        color = '#d48806';
        break;
      case 'Bupa':
        background = '#f0f5ff';
        color = '#1d39c4';
        break;
      case 'Present':
      case 'Return':
      case 'Active':
      case 'To Receive and Bill':
        background = '#e6fffb';
        color = '#08979c';
        break;
      case 'Absent':
      case 'Inactive':
        background = '#fff1f0';
        color = '#cf1322';
        break;
      case 'Return Issued':
      case 'On Leave':
      case 'Credit Note Issued':
        background = '#fff7e6';
        color = '#d46b08';
        break;
      case 'Pending to complete patient file':
        background = '#68d0d02f';
        color = '#68d0d0';
        break;
      default:
        background = '#d9d9d9';
        color = '#595959';
        break;
      case '':
      case null:
        break;
    }
    return { color, background, title };
  }, [status]);

  return { color, background, title };
};

const StatusTag = ({ status }) => {
  const { color, background, title } = useStatusTagStyles(status);

  return (
    <Tag
      style={{
        color: color,
        background: background,
        padding: '7px 12px 8px 12px',
        border: 'none',
      }}
    >
      {title ? title : status}
    </Tag>
  );
};

export default StatusTag;
